
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { GenericRepository } from "../generic/GenericRepository";
import { environment } from "src/app/globals";
import { IUserRepository } from "./IUserRepository";
import { User } from "src/app/models/User.model";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { GetLogin } from "src/app/models/get-login.model";
import { Usertf } from 'src/app/models/Usertf.model';
import { Login } from "src/app/models/login.model";

@Injectable({ providedIn: 'root' })
export class UserRepository extends GenericRepository<User> implements IUserRepository {
  httpOptions: any = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  selectedContacts: string[] = [];
  onSelectedContactsChanged: BehaviorSubject<any>;
  onUserAccessReightsChanged: BehaviorSubject<any>;
  onFilterChanged: Subject<any>;
  constructor(protected _http: HttpClient) {

    super(_http, environment.gbaseURL, environment.gserverName);
    this.onSelectedContactsChanged = new BehaviorSubject([]);
    this.onUserAccessReightsChanged = new BehaviorSubject([]);
    this.onFilterChanged = new Subject();
  }



  AddOrUpdateUser(user: User) {
    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'Content-Type': 'application/json' });
    return this._http.post(environment.gserverName + '/GDS/api/user/addOrUpdateUserDetails', user, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }
  GetUsers() {
    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });
    return this._http.post(environment.gserverName + '/GDS/api/user/getusers', null, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }
  GetUserAccessRights(RecordID) {
    debugger
    let params = new HttpParams();
    params = params.append('RecordID', RecordID);
    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'Content-Type': 'application/json' });
    return this._http.post(environment.gserverName + '/GDS/api/user/getstaffaccesscontrol', null, { headers: reqHeader, params: params }).pipe(map(this.extractData), catchError(this.handleError));
  }

  SaveUserAccessRights(rights: any, RecordID) {
    debugger
    let params = new HttpParams();
    params = params.append('RecordID', RecordID);
    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'Content-Type': 'application/json' });
    return this._http.post(environment.gserverName + '/GDS/api/user/saveaccesscontrol', rights, { headers: reqHeader, params: params }).pipe(map(this.extractData), catchError(this.handleError));
  }

  GetLogin(gerLogin: GetLogin) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True', 'Content-Type': 'application/json' });
    return this._http.post(environment.gserverName + '/GDS/api/user/getlogin', gerLogin, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }
  GetAccessRights() {

    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });
    return this._http.post(environment.gserverName + '/GDS/api/user/getUserAccessRights', null, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }


  GetUsersById() {
    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });
    return this._http.post(environment.gserverName + '/GDS/api/user/getuserbyid', null, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }
  SendAuthenticationCode(Usertf: Usertf) {


    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });
    return this._http.post(environment.gserverName + '/GDS/api/user/sendauthenticationcode', Usertf, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }

  UpdateClientAuthenticationCode(Usertf: Usertf) {

    var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });
    return this._http.post(environment.gserverName + '/GDS/api/user/updateclientauthenticationcode', Usertf, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
  }

    VerifyUserEmail(user: Login) {
        var reqHeader = new HttpHeaders({ 'No-Auth': 'True', 'Content-Type': 'application/json' });
        return this._http.post(environment.gserverName + '/GDS/api/user/verifyuseremail', user, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
    }

    VerifyPasswordResetCode(user: Login) {
        var reqHeader = new HttpHeaders({ 'No-Auth': 'True', 'Content-Type': 'application/json' });
        return this._http.post(environment.gserverName + '/GDS/api/user/verifypasswordresetcode', user, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
    }

    ResetUserPassword(user: Login) {
        var reqHeader = new HttpHeaders({ 'No-Auth': 'True', 'Content-Type': 'application/json' });
        return this._http.post(environment.gserverName + '/GDS/api/user/resetuserpassword', user, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetUserCompanies() {
        var reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });
        return this._http.post(environment.gserverName + '/GDS/api/user/GetUserCompanies', null, { headers: reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
    }
}
